import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=3f9e6f22&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"
import style0 from "./Setting.vue?vue&type=style&index=0&id=3f9e6f22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e6f22",
  null
  
)

export default component.exports